// src/pages/auth.content.js

export const AUTH_CONTENT = {
    en: {
        seo: {
            // Базовый SEO-фолбэк для auth-страниц
            title:
                "Join Virtalibry – Register or Log in to Access Author Tools and Reader Features",
            description:
                "Register for free or log in to Virtalibry to manage books, access KDP tools, collect reader feedback, and grow your author platform.",
            keywords:
                "Virtalibry, author login, KDP tools, reader feedback, book marketing tools, author dashboard",
            url: "https://virtalibry.com",
            image: "https://virtalibry.com/preview/virtalibry-auth.jpg",
            type: "website",
            canonical: "https://virtalibry.com",

            // SEO по типам страниц
            loginTitle:
                "Login to Virtalibry – Access Your Author Dashboard and Tools",
            loginDescription:
                "Log in to manage your books, use KDP tools, track activity, and access your Virtalibry author workspace.",
            loginKeywords:
                "Virtalibry login, author dashboard login, KDP tools login",

            signupTitle:
                "Create a Virtalibry Account – Access Author Tools, Reader Feedback & Book Growth Features",
            signupDescription:
                "Register for free to access your Virtalibry dashboard, manage books, collect reader feedback, use KDP tools, and grow your author platform.",
            signupKeywords:
                "Virtalibry registration, author account, KDP tools, reader feedback platform, book marketing tools",



            resetTitle: "Reset Your Virtalibry Password",
            resetDescription:
                "Forgot your password? Request a secure reset link and restore access to your Virtalibry account, books, and reviews.",
            resetKeywords:
                "reset Virtalibry password, forgot Virtalibry password, password recovery",

            setNewTitle: "Set a New Password – Virtalibry",
            setNewDescription:
                "Create a new secure password for your Virtalibry account and continue getting verified Amazon reviews and earning Virts.",
            setNewKeywords:
                "set new Virtalibry password, change Virtalibry password",

            faq: [
                {
                    q: "What do I get after registering at Virtalibry?",
                    a: "You’ll access your dashboard where you can upload your book, assign Virts, track reviews, and earn rewards as both an author and a reader."
                },
                {
                    q: "Is it free to join Virtalibry?",
                    a: "Yes, we offer a free plan that lets you add one book and receive reviews indefinitely. Paid plans give you additional books, tools, and advanced analytics."
                },
                {
                    q: "Can I earn money as a reader?",
                    a: "Yes. You can read books, leave thoughtful reviews, and earn Virts, which can be redeemed for bonuses or used to get reviews for your own books."
                }
            ],

            webPage: {
                name: "Virtalibry Registration and Login",
                url: "https://virtalibry.com/register",
                description:
                    "Join Virtalibry to get verified Amazon reviews, run book polls, and grow as an author. Register for free or log in to access your dashboard."
            },

            breadcrumbHomeName: "Home",
            breadcrumbLoginName: "Login",
            breadcrumbRegisterName: "Sign up",
            breadcrumbResetName: "Password Recovery",
            breadcrumbSetNewName: "Set New Password"
        },

        headings: {
            // Блоки над формой
            regTitle: "Create Your Virtalibry Account",
            regSubtitleMain:
                "Access your author dashboard, reader tools, and book growth features.",
            regSubtitleStrong: "Join for free.",
            regSupportText:
                "Use Virtalibry to manage your books, collect reader feedback, run book polls, and grow your visibility with a structured workflow.",

            loginTitle: "Welcome Back to Virtalibry",
            loginHeadline: "Manage books, run reader Pools, and track feedback from your Virtalibry dashboard.",
            loginSubtitleLine1:
                "Log in to manage your books, track activity, use tools, and stay connected with your Virtalibry workspace.",
            loginSubtitleLine2:
                "Everything you need for your next step as an author or reader is in one place.",

            recoveryTitle: "Recover Your Virtalibry Account",
            recoveryHeadline:
                "Reset your password and return to your dashboard.",
            recoverySubtitleLine1:
                "Enter your email address and we will send a secure link to restore access to your books, reader Pools, and tools.",
            point1: "Manage books in one place",
            point2: "Collect reader feedback",
            point3: "Use practical KDP tools",
        },

        card: {
            headerSignup: "Create Your Account",
            headerLogin: "Sign In",
            headerSetNewPassword: "Set New Password",
            headerRecovery: "Password Recovery"
        },

        form: {
            nameLabel: "Name",
            namePh: "Enter your name",
            emailLabel: "E-mail",
            emailPh: "Enter your email",
            passwordLabel: "Password",
            passwordPh: "Enter your password",
            confirmLabel: "Confirm Password",
            confirmPh: "Confirm your password",

            btnLogin: "Login",
            btnCreate: "Sign up",
            btnSavePassword: "Save Pass",
            btnSendReset: "Send Link",

            forgot: "Forgot your password?",
            invitedBy: "You were invited by"
        },

        toasts: {
            enterNewAndConfirm:
                "Please enter a new password and confirm it.",
            passwordsMismatch: "Passwords do not match",
            resetOk:
                "Your password has been reset successfully! Now You can Login with New Password.",
            resetErr: "Error resetting password.",
            enterEmail: "Please enter your email.",
            resetLinkSent:
                "Password reset link has been sent to your email!",
            resetLinkErr: "Error sending reset link.",
            enterEmailAndPass:
                "Please enter your email and password",
            googleFail:
                "Google login failed. Please try again.",
            googleAuthFailed:
                "Google authentication failed.",
            openVerify: "Open verification page",
            genericError: "Error during request"
        },

        validation: {
            passRule:
                "Password must be at least 5 characters, include a number and an uppercase letter.",
            emailRule:
                "This is not a valid email. Please enter a correct email address."
        }
    },

    es: {
        seo: {
            title:
                "Únete a Virtalibry – Regístrate o inicia sesión para conseguir reseñas en Amazon, ganar Virts y crecer",
            description:
                "Regístrate gratis o inicia sesión en Virtalibry, la plataforma para conseguir reseñas de libros en Amazon. Consigue reseñas verificadas, gana Virts y conéctate con otros autores.",
            keywords:
                "reseñas de libros en Amazon, reseñas KDP, inicio de sesión autores, registro de reseñas de libros, marketing de libros, reseñas verificada de compra, Virtalibry login",
            url: "https://virtalibry.com/es",
            image: "https://virtalibry.com/preview/virtalibry-auth.jpg",
            type: "website",
            canonical: "https://virtalibry.com/es",

            loginTitle:
                "Inicia sesión en Virtalibry – Accede a tu panel de autor y lector",
            loginDescription:
                "Inicia sesión para gestionar tus libros, seguir tus reseñas, ganar Virts y conectar con otros autores y lectores.",
            loginKeywords:
                "login Virtalibry, inicio de sesión autor, intercambio de reseñas Amazon",

            signupTitle:
                "Crea una cuenta en Virtalibry – Consigue de 6 a 12 reseñas verificadas cada semana",
            signupDescription:
                "Regístrate gratis para empezar a intercambiar reseñas verificadas en Amazon, ganar Virts y hacer crecer tu plataforma de autor con opiniones reales de lectores.",
            signupKeywords:
                "registro Virtalibry, alta Virtalibry, intercambio de reseñas Amazon, conseguir reseñas de libros",

            resetTitle: "Restablecer tu contraseña de Virtalibry",
            resetDescription:
                "¿Olvidaste tu contraseña? Solicita un enlace seguro para restablecerla y recuperar el acceso a tu cuenta de Virtalibry, libros y reseñas.",
            resetKeywords:
                "restablecer contraseña Virtalibry, olvidar contraseña Virtalibry, recuperar contraseña",

            setNewTitle: "Crear una nueva contraseña – Virtalibry",
            setNewDescription:
                "Crea una nueva contraseña segura para tu cuenta de Virtalibry y sigue obteniendo reseñas verificadas en Amazon y ganando Virts.",
            setNewKeywords:
                "nueva contraseña Virtalibry, cambiar contraseña Virtalibry",

            faq: [
                {
                    q: "¿Qué obtengo al registrarme en Virtalibry?",
                    a: "Obtendrás acceso a tu panel donde podrás subir tus libros, asignar Virts, seguir las reseñas y ganar recompensas como autor y como lector."
                },
                {
                    q: "¿Es gratis unirse a Virtalibry?",
                    a: "Sí. Ofrecemos un plan gratuito que te permite añadir un libro y recibir reseñas sin límite de tiempo. Los planes de pago añaden más libros, herramientas y analíticas avanzadas."
                },
                {
                    q: "¿Puedo ganar dinero como lector?",
                    a: "Sí. Puedes leer libros, dejar reseñas detalladas y ganar Virts, que podrás canjear por bonos o usar para conseguir reseñas para tus propios libros."
                }
            ],

            webPage: {
                name: "Registro e inicio de sesión en Virtalibry",
                url: "https://virtalibry.com/es/register",
                description:
                    "Únete a Virtalibry para conseguir reseñas verificadas en Amazon, hacer encuestas de libros y crecer como autor. Regístrate gratis o inicia sesión para acceder a tu panel."
            },

            breadcrumbHomeName: "Inicio",
            breadcrumbLoginName: "Iniciar sesión",
            breadcrumbRegisterName: "Registro",
            breadcrumbResetName: "Recuperar contraseña",
            breadcrumbSetNewName: "Nueva contraseña"
        },

        headings: {
            regTitle: "¡Consigue de 6 a 12 reseñas verificadas cada semana!",
            regSubtitleMain:
                "Mejora tu presencia en Amazon con reseñas reales y constantes.",
            regSubtitleStrong: "¡Regístrate hoy gratis!",

            loginTitle: "¡Bienvenido de nuevo a Virtalibry!",
            loginHeadline: "Más reseñas, más visibilidad, más oportunidades.",
            loginSubtitleLine1:
                "Inicia sesión para gestionar tus libros, seguir tus reseñas, ganar Virts y conectar con otros autores y lectores.",
            loginSubtitleLine2: "Tu próxima oportunidad empieza aquí."
        },

        card: {
            headerLogin: "Iniciar sesión",
            headerSignup: "Registro",
            headerSetNewPassword: "Crear nueva contraseña",
            headerRecovery: "Recuperar contraseña"
        },

        form: {
            nameLabel: "Nombre",
            namePh: "Ingresa tu nombre",
            emailLabel: "E-mail",
            emailPh: "Ingresa tu email",
            passwordLabel: "Contraseña",
            passwordPh: "Ingresa tu contraseña",
            confirmLabel: "Confirmar contraseña",
            confirmPh: "Confirma tu contraseña",

            btnLogin: "Iniciar sesión",
            btnCreate: "Registrarse",
            btnSavePassword: "Guardar contraseña",
            btnSendReset: "Enviar enlace",

            forgot: "¿Olvidaste tu contraseña?",
            invitedBy: "Te invitó"
        },

        toasts: {
            enterNewAndConfirm:
                "Ingresa una nueva contraseña y confírmala.",
            passwordsMismatch: "Las contraseñas no coinciden",
            resetOk:
                "Tu contraseña se restableció correctamente. Ahora puedes iniciar sesión con la nueva contraseña.",
            resetErr: "Error al restablecer la contraseña.",
            enterEmail: "Ingresa tu email.",
            resetLinkSent:
                "Te hemos enviado el enlace para restablecer la contraseña.",
            resetLinkErr:
                "Error al enviar el enlace de restablecimiento.",
            enterEmailAndPass:
                "Ingresa tu email y contraseña",
            googleFail:
                "Falló el inicio de sesión con Google. Inténtalo de nuevo.",
            googleAuthFailed:
                "Falló la autenticación de Google.",
            openVerify: "Abrir página de verificación",
            genericError: "Error durante la solicitud"
        },

        validation: {
            passRule:
                "La contraseña debe tener al menos 5 caracteres e incluir un número y una letra mayúscula.",
            emailRule:
                "Email no válido. Ingresa una dirección de correo correcta."
        }
    }
};

export const getAuthContent = (lang) => AUTH_CONTENT?.[lang] || AUTH_CONTENT.en;
